/** Keyboard and ARIA wiring between a field and its `SuggestionList`. */

export function suggestionOptionId(listId: string, index: number): string {
  return `${listId}-option-${String(index)}`;
}

/** The active option after Up or Down, wrapping round; `null` for any other key. */
export function nextSuggestionIndex(key: string, current: number, count: number): number | null {
  if (count === 0 || (key !== "ArrowDown" && key !== "ArrowUp")) return null;
  return (current + (key === "ArrowDown" ? 1 : count - 1)) % count;
}
